/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Community || (M.Template.Community = {});
M.Template.Community.Calendar || (M.Template.Community.Calendar = {});

M.Template.Community.Calendar.SubscriptionIcon = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:EVENTS
   */
__p+='\n\n<div class="calendarIconContainer">\n  <img class="calendarIconBlack sprite"\n    src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'">\n</div>\n';
}
return __p;
});

M.Template.Community.Calendar.SubscriptionPopup = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:EVENTS
   */
__p+='\n\n<div class="popupBox">\n  <div class="popupHeader">\n    <h3 class="header tc">ADD TO CALENDAR</h3>\n  </div>\n  <div class="copySubscriptionLink">\n    <h4 class="subheader">COPY SUBSCRIPTION LINK</h4>\n    <input class="subscriptionLink" type="text">\n  </div>\n  <div class="learnHowToSubscribe">\n    <h4 class="subheader">LEARN HOW TO SUBSCRIBE WITH...</h4>\n    <a class="calendarServiceLink actionLink"\n      href="https://minteddesign.zendesk.com/hc/en-us/articles/115003615983"\n      target="_blank">\n      <img class="calendarServiceIcon sprite googleCalendarIcon"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'">\n      <span class="calendarServiceName">GOOGLE CALENDAR</span>\n      <div class="smallArrow"></div>\n    </a>\n    <a class="calendarServiceLink actionLink"\n      href="https://minteddesign.zendesk.com/hc/en-us/articles/115003615983"\n      target="_blank">\n      <img class="calendarServiceIcon sprite outlookIcon"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'">\n      <span class="calendarServiceName">OUTLOOK</span>\n      <div class="smallArrow"></div>\n    </a>\n    <a class="calendarServiceLink actionLink"\n      href="https://minteddesign.zendesk.com/hc/en-us/articles/115003615983"\n      target="_blank">\n      <img class="calendarServiceIcon sprite iCalIcon"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'">\n      <span class="calendarServiceName">ICAL</span>\n      <div class="smallArrow"></div>\n    </a>\n  </div>\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
